module.exports = {
  VUE_APP_ENC: 'U2FsdGVkX1/ScWvcZu1uTZtREca4Y4N+rEpa120GJrU=',
  VUE_APP_API_HOST:
    'U2FsdGVkX1+//PKWXqBQPl9MVUtnsObroV2XA7ye7m/OctbnoqLCPxRy7SXEFyQ8',
  VUE_APP_GOOGLE_MAP_API_KEY:
    'U2FsdGVkX19MZL9lURcmpxvc0Ccp1Q/uH4ZDj0tI5KN5U4A5mgmGlSMOBEkcn9VvbAFZd3+puGKREDAEz9rX3Q==',
  VUE_APP_GEOIP_API_KEY: 'U2FsdGVkX19uFbawaJBDX+j8gxeYXuF9uJCxK7NLrOE=',
  VUE_APP_S3D_CLOUDFRONT_ID: 'U2FsdGVkX1+P1GD2V01VpZT04M9UdOY5gVmPCkw97sM=',
  VUE_APP_S3D_BUCKET:
    'U2FsdGVkX19QbXEiUABZ1h+SV46szPwKyxnl6L4HAhLXnC7DHX2vRBAE8DRLl5pOZTvKAf9Z7SpgUfa87KVdYw==',
  VUE_APP_SENDGRID_API_KEY:
    'U2FsdGVkX1+gOdEqzo+lDbnNLDlNDsr3ehnwZtyVpxVwHegVI+JBNEkyS3vMZ48x1fH51x1fhHjzJVQUpNSeMJv+i0YGZb3IevHWuQyXcrXnGAnmm9Vo6s9ultsUaQMy',
  VUE_APP_MAILCHIMP_API_KEY:
    'U2FsdGVkX19t+9mPzV8OjG5COiYMgC3qIMjq5XdujvOQxoVgXjm6C/J38uUndSYxJWQhAQizuSVVbGhZua12vQ==',
  VUE_APP_GRAPHQL_AUTH:
    'U2FsdGVkX19YhEaoM93ppmMI+nzG/9j6dFZ6dLWniFCHXeZFaxPZjng7KZ7Zre9m',
  BASE_PDF_DL_URL: 'U2FsdGVkX1/EgdB2YWpS7DVv1b9x25SXbJygQclRcyQ55nuwubwV9wFynLD7tkqYfInFq6vbMGUvnqrpr1i1ejtdeIBWcorP32KwnWyIHqozq0Cgp9ZLgjrJTYFvV43/'
}
